import { WSButton, WSIcon } from "@wingspanhq/fe-component-library";
import classNames from "classnames";
import React, { useState } from "react";
import { useUserId } from "../../query/hooks/helpers";
import { useAdvocate } from "../../query/user";
import { WSQuery } from "../../query/WSQuery";
import { Calendly } from "../Calendly/Calendly";
import styles from "./MemberAdvocateWidget.module.scss";

type Props = {
  iconClassName?: string;
};

export const MemberAdvocateWidget: React.FC<Props> = ({ iconClassName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const userId = useUserId();
  const advocateQuery = useAdvocate(userId);
  return (
    <WSQuery query={advocateQuery}>
      {({ data: advocate }) => {
        return (
          <div
            className={styles.widget}
            onBlur={({ currentTarget, relatedTarget }) => {
              if (currentTarget.contains(relatedTarget as any)) {
                return;
              }

              setIsOpen(false);
            }}
            tabIndex={0}
          >
            <div
              className={classNames(styles.icon, iconClassName)}
              onClick={() => setIsOpen(!isOpen)}
            >
              <WSIcon name="question" />
            </div>

            <div
              className={classNames(styles.dropdown, {
                [styles.active]: isOpen
              })}
            >
              <div className={styles.close} onClick={() => setIsOpen(false)}>
                <WSIcon name="close" />
              </div>
              <h2 className={styles.title}>Need assistance?</h2>
              <div className={styles.content}>
                <div className={styles.photo}>
                  <img src={advocate.photoUrl} />
                </div>
                <div>
                  <div className={styles.name}>{advocate.firstName}</div>
                  <div className={styles.role}>Your member advocate</div>
                </div>
              </div>
              <Calendly>
                {({ onOpen }) => (
                  <WSButton onClick={onOpen}>
                    Schedule a call with {advocate.firstName}
                  </WSButton>
                )}
              </Calendly>
            </div>
          </div>
        );
      }}
    </WSQuery>
  );
};
